import { render, staticRenderFns } from "./YearlyStatusList.vue?vue&type=template&id=68cf86a6&scoped=true&"
import script from "./YearlyStatusList.vue?vue&type=script&lang=ts&"
export * from "./YearlyStatusList.vue?vue&type=script&lang=ts&"
import style0 from "./YearlyStatusList.vue?vue&type=style&index=0&id=68cf86a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cf86a6",
  null
  
)

export default component.exports